import React from 'react';
import Layout from "../components/layout";
import { Link } from 'gatsby';
import Breadcrumb from '../components/breadcrumb';
import '../components/button/_button.scss';


class SupportPage extends React.Component {
	render() {
		return (
			<Layout >
				<main className="container-fluid">
					<Breadcrumb title="Support the site" />
					<div className="row">
						<div className="col-md-10 col">
							<p>
								Any support to help cover the server/coding as well as help me keep on adding more features like: 
							</p>
							<ul>
								<li>Season long Records</li>
								<li>Player Records</li>
								<li>Rosters</li>
								<li>Full Game logs</li>
								<li>Draft Recaps</li>
								<li>Power Rankings</li>
								<li>Playoff Odds</li>
								<li>Designs/Skins</li>
								<li>Compatibility with other Fantasy Providers</li>
							</ul>
							<p>
								To see the full list with all the details go to the <Link to="/roadmap/" >Roadmap page</Link> 
							</p>
							<p>
								I'm also a Freelance Web Developer you can check out my work at <a href="https://squidsource.com/" target="_blank" rel="noopener noreferrer">https://squidsource.com/</a>
							</p>
							<p>
								If you have an interest in helping support the site, please use Zelle (Preferred no transaction fees), Paypal, or Patreon buttons.<br />
							</p>
								<img className="mr-2" src="https://www.zellepay.com/sites/default/files/zelle%20logo%20card_0.jpg" width="100" alt="Zelle" /> fabianbrenes [at] gmail [dot] com

								<a className="bmc-button my-3" target="_blank" rel="noopener noreferrer" href="https://www.paypal.com/paypalme2/FabianBrenes">
									<img className="mr-2" src="https://www.paypalobjects.com/webstatic/icon/pp258.png" width="40" alt="Paypal.me" />
									<span>Paypal Me</span>
								</a>
								
							<a className="bmc-button my-3" target="_blank" rel="noopener noreferrer" href="https://www.patreon.com/bePatron?u=13567542" data-patreon-widget-type="become-patron-button">
								<img className="mr-2" src="https://fantasy-franchise.com/img/patreon.jpg" width="40" alt="Patreon" />
									<span>Become a Patron!</span>
								</a>
								
							
						</div>
					</div>

				</main>
			</Layout>
			);
	}
}
export default SupportPage;


